import { RouteConfig } from 'vue-router';

import { Errors } from '@/enums/errors.enum';
import store from '@/store/store';

export const rolesRoute: RouteConfig = {
  name: 'roles',
  path: '',
  component: () => import(/* webpackChunkName: "RoleList" */ '@/views/mainRoute/role/List.vue'),
  meta: {
    authorized: true
  },
  beforeEnter: (to: any, from: any, next: any) => {
    store
      .dispatch('role/list', { count: -1 })
      .then(() => next())
      .catch(() => store.dispatch('notifyError', { title: Errors.ROLE_CANNOT_LIST }));
  }
};
